module.exports = __webpack_public_path__ + "img/assinatura.3759114c.svg";